import { ShowButtonsPaginacion } from "../../utils/paginacion/ShowButtonsPaginacion";
import { Table } from "../molecules/Table";
import { TableBody } from "../molecules/TableBody";
import { TableHead } from "../molecules/TableHead";

export const DataTable = ({
  columnas = [],
  paginas = [],
  paginaInicial = 1,
  paginaFinal = 1,
  paginaActual = 1,
  setPaginaActual = () => {},
  children,
}) => {
  const mostrarPaginacion = paginas.length > 1;

  return (
    <main className="overflow-y-auto bg-[#FDFDFD] p-5">
      <div className="bg-[#FFFFFF] p-6">
        <Table>
          <TableHead>
            {columnas.map((columna, i) => (
              <th
                key={columna}
                className={i < columnas.length - 1 ? "border-r border-slate-300" : ""}
              >
                {columna}
              </th>
            ))}
          </TableHead>
          <TableBody>{children}</TableBody>
        </Table>
      </div>

      {mostrarPaginacion && (
        <div className="grid justify-center gap-1 pt-2">
          <ShowButtonsPaginacion
            paginaInicial={paginaInicial}
            paginaFinal={paginaFinal}
            paginaActual={paginaActual}
            setPaginaActual={setPaginaActual}
            paginas={paginas}
          />
        </div>
      )}
    </main>
  );
};
